import React from 'react';
import { FadeIn, Section, FloralSeparator } from '../ui/Shared';
export const ProductPresentation = () => <Section className="bg-cream" data-id="element-132">
    <div className="grid lg:grid-cols-2 gap-8 items-center" data-id="element-133">
      <FadeIn data-id="element-134">
        <p className="italic text-brown-text/70 mb-2" data-id="element-135">Presentando:</p>
        <h1 className="text-5xl md:text-6xl font-bold text-pink-deep mb-4" data-id="element-136">
          🌸 RENACER DESPUÉS DEL PARTO
        </h1>
        <h2 className="text-2xl italic text-celeste-deep mb-6 font-heading" data-id="element-137">
          El método paso a paso para recuperar tu estabilidad emocional, tu
          descanso y tu paz interior — en 4 semanas.
        </h2>

        <div className="border-l-4 border-pink-border pl-6 space-y-3 mb-6" data-id="element-138">
          <p className="font-bold" data-id="element-139">
            Un proceso completo, amoroso y estructurado.
          </p>
          <p className="font-bold" data-id="element-140">
            Diseñado específicamente para madres en el postparto.
          </p>
          <p className="font-bold" data-id="element-141">
            Para que no tengas que atravesarlo sola, a ciegas o improvisando.
          </p>
        </div>

        <p className="mb-3 font-medium" data-id="element-142">
          Con Renacer Después del Parto vas a tener:
        </p>
        <ul className="space-y-2 mb-6" data-id="element-143">
          {['Un camino claro, organizado por etapas emocionales', 'Herramientas prácticas para los momentos difíciles', 'Material listo para usar cuando la ansiedad aparece', 'La certeza de que lo que sentís tiene explicación y solución', 'Un proceso que podés hacer a tu ritmo, desde tu casa, cuando puedas'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-144">
              <span className="text-pink-primary mt-1" data-id="element-145">✦</span>
              <span data-id="element-146">{item}</span>
            </li>)}
        </ul>

        <p className="text-2xl italic font-heading text-pink-deep font-bold" data-id="element-147">
          Primero comprendés. Después sanás. Finalmente, renacés.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} className="relative" data-id="element-148">
        <div className="absolute inset-0 bg-gradient-to-tr from-pink-light to-celeste-light rounded-3xl transform rotate-3 scale-105 -z-10" data-id="element-149"></div>
        <img src="https://cdn.magicpatterns.com/uploads/uRf3NDZHdwbat5tQQ2nVPJ/WhatsApp_Image_2026-03-15_at_17.08.59_(2).jpg" alt="Renacer Después del Parto Tomos" className="rounded-3xl shadow-2xl w-full object-cover" data-id="element-150" />
      </FadeIn>
    </div>
  </Section>;
export const TomosSection = () => <Section className="bg-white" data-id="element-151">
    <FadeIn data-id="element-152">
      <h2 className="text-4xl md:text-5xl text-center mb-10 italic" data-id="element-153">
        ¿Qué vas a recibir?
      </h2>
    </FadeIn>

    <div className="grid lg:grid-cols-2 gap-6" data-id="element-154">
      {/* Tomo 1 */}
      <FadeIn delay={0.1} data-id="element-155">
        <div className="bg-pink-light border border-pink-border rounded-3xl p-6 md:p-8 h-full flex flex-col" data-id="element-156">
          <div className="mb-6 text-center" data-id="element-157">
            <h3 className="text-3xl font-bold text-pink-deep mb-2" data-id="element-158">
              🌸 TOMO I
            </h3>
            <h4 className="text-2xl italic text-brown-text font-heading mb-2" data-id="element-159">
              "No Estás Sola"
            </h4>
            <p className="text-pink-deep font-medium" data-id="element-160">
              Comprensión y estabilización emocional
            </p>
          </div>

          <div className="space-y-3 mb-6 text-brown-text/90 italic" data-id="element-161">
            <p data-id="element-162">Este primer tomo te abraza en el momento más difícil.</p>
            <p data-id="element-163">Cuando todavía no entendés bien qué está pasando.</p>
            <p data-id="element-164">Cuando la culpa y el agotamiento son lo que más sentís.</p>
            <p data-id="element-165">
              Cuando necesitás que alguien te diga:{' '}
              <span className="font-bold" data-id="element-166">
                "Lo que sentís es real, tiene nombre y tiene salida."
              </span>
            </p>
          </div>

          <p className="font-bold mb-3" data-id="element-167">Dentro vas a encontrar:</p>
          <ul className="space-y-2 mb-6 flex-grow" data-id="element-168">
            {['Explicación clara de la depresión postparto y los cambios hormonales', 'Diferencias entre baby blues y depresión postparto — entendé en qué punto estás', 'Validación emocional profunda — dejá de sentirte "defectuosa"', 'Primeras herramientas para manejar la ansiedad y los desbordes', 'Ejercicios de respiración y reflexión que podés hacer hoy', 'Cómo pedir ayuda y empezar a construir tu red de apoyo'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-169">
                <span className="text-pink-primary mt-1" data-id="element-170">🌸</span>
                <span data-id="element-171">{item}</span>
              </li>)}
          </ul>

          <div className="bg-white/60 p-5 rounded-xl border border-pink-border/50 mt-auto" data-id="element-172">
            <p className="font-bold text-pink-deep" data-id="element-173">
              🎯 Al terminar el Tomo I vas a entender exactamente qué te está
              pasando — y vas a dejar de sentirte sola en esto.
            </p>
          </div>
        </div>
      </FadeIn>

      {/* Tomo 2 */}
      <FadeIn delay={0.2} data-id="element-174">
        <div className="bg-celeste-light border border-celeste-primary/30 rounded-3xl p-6 md:p-8 h-full flex flex-col" data-id="element-175">
          <div className="mb-6 text-center" data-id="element-176">
            <h3 className="text-3xl font-bold text-celeste-deep mb-2" data-id="element-177">
              💙 TOMO II
            </h3>
            <h4 className="text-2xl italic text-brown-text font-heading mb-2" data-id="element-178">
              "Sanación Profunda"
            </h4>
            <p className="text-celeste-deep font-medium" data-id="element-179">
              Transformación y reconstrucción del equilibrio
            </p>
          </div>

          <div className="space-y-3 mb-6 text-brown-text/90 italic" data-id="element-180">
            <p data-id="element-181">Este segundo tomo te guía hacia la reconstrucción.</p>
            <p data-id="element-182">
              Cuando ya entendés lo que viviste y estás lista para sanar de
              verdad.
            </p>
            <p data-id="element-183">
              Cuando querés recuperar tu autoestima, tu identidad y tu calma.
            </p>
            <p data-id="element-184">
              Cuando necesitás herramientas concretas para tu día a día como
              mamá.
            </p>
          </div>

          <p className="font-bold mb-3" data-id="element-185">Dentro vas a encontrar:</p>
          <ul className="space-y-2 mb-6 flex-grow" data-id="element-186">
            {['Trabajo sobre creencias limitantes y autoexigencia materna', 'Reconexión con tu cuerpo y regulación del sistema nervioso', 'Ejercicios para fortalecer el vínculo con tu bebé — sin presión', 'Diseño de rutinas mínimas que devuelven estabilidad', 'Estrategias para establecer límites y pedir apoyo con seguridad', 'Plantillas prácticas y rituales diarios que realmente funcionan'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-187">
                <span className="text-celeste-deep mt-1" data-id="element-188">💙</span>
                <span data-id="element-189">{item}</span>
              </li>)}
          </ul>

          <div className="bg-white/60 p-5 rounded-xl border border-celeste-primary/30 mt-auto" data-id="element-190">
            <p className="font-bold text-celeste-deep" data-id="element-191">
              🎯 Al terminar el Tomo II vas a sentir que recuperaste el control
              de tu vida emocional — y que volviste a ser vos.
            </p>
          </div>
        </div>
      </FadeIn>
    </div>

    <FadeIn delay={0.4} className="text-center mt-10" data-id="element-192">
      <FloralSeparator data-id="element-193" />
      <p className="text-xl italic font-heading text-pink-deep font-bold" data-id="element-194">
        ✨ Juntos, los dos tomos forman un proceso completo de 4 semanas:
        <br data-id="element-195" />
        Comprendés → Sanás → Renacés
      </p>
    </FadeIn>
  </Section>;
export const ResultsSection = () => {
  const results = [{
    icon: '🌊',
    title: 'Estabilidad emocional real',
    desc: 'Dejarás de sentir que vivís en una montaña rusa. Vas a entender tus emociones y gestionarlas con calma.'
  }, {
    icon: '🌙',
    title: 'Descanso que se recupera',
    desc: 'Herramientas prácticas para relajar tu mente, reducir la ansiedad nocturna y volver a dormir.'
  }, {
    icon: '🤍',
    title: 'La culpa que se va',
    desc: 'Vas a dejar de castigarte por no sentirte "perfecta". Lo que te pasa tiene explicación — y solución.'
  }, {
    icon: '💪',
    title: 'Autoestima renovada',
    desc: 'Te vas a sentir más capaz, más segura y más conectada con tu rol de mamá — sin perder quien sos.'
  }, {
    icon: '🧠',
    title: 'Ansiedad bajo control',
    desc: 'Recursos concretos para cuando aparezcan los momentos difíciles. Vas a saber qué hacer.'
  }, {
    icon: '🌸',
    title: 'Tu identidad, de vuelta',
    desc: 'No sos solo mamá. Este proceso te ayuda a reencontrarte con vos misma — con la mujer que seguís siendo.'
  }, {
    icon: '👶',
    title: 'Vínculo más profundo',
    desc: 'Al sentirte más estable emocionalmente, vas a poder estar más presente — y disfrutar más la maternidad.'
  }, {
    icon: '🕊️',
    title: 'Paz interior',
    desc: 'Esa sensación de calma que hoy parece tan lejana — vuelve. Paso a paso. A tu ritmo.'
  }];
  return <Section className="bg-cream" data-id="element-196">
      <FadeIn data-id="element-197">
        <h2 className="text-4xl md:text-5xl text-center mb-10 italic" data-id="element-198">
          Lo que va a cambiar en tu vida
        </h2>
      </FadeIn>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-199">
        {results.map((res, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-200">
            <div className={`p-5 rounded-2xl h-full border ${i % 2 === 0 ? 'bg-pink-light/50 border-pink-border' : 'bg-celeste-light/50 border-celeste-primary/30'} hover:-translate-y-1 transition-transform duration-300`} data-id="element-201">
              <div className="text-4xl mb-3" data-id="element-202">{res.icon}</div>
              <h3 className="text-xl font-bold text-pink-deep mb-2 font-heading leading-tight" data-id="element-203">
                {res.title}
              </h3>
              <p className="text-sm text-brown-text/80" data-id="element-204">{res.desc}</p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};